import React, { useContext, useCallback, useMemo } from "react";
import {
  View,
  StyleSheet,
  FlatList,
  Text,
  TouchableWithoutFeedback,
} from "react-native";
import Icon from "react-native-vector-icons/Feather";

import { VoicemailsContext } from "~/contexts/VoicemailsContext";

import IconButton from "~/components/Buttons/IconButton/index";
import Heading from "~/components/Heading/index";
import palette from "~/styles/palette";
import Row from "~/layouts/Row";
import Col from "~/layouts/Col";
import { getSmartTimestamp } from "~/helpers/day";
import dayjs from "~/helpers/day";
import useTwilio from "~/hooks/useTwilio";
import Engage from "../../services/engage";

const VoicemailList = ({ onVoicemailPress, style = {} }) => {
  const { loading, voicemails, getVoicemails, refreshVoicemails, nextPage } =
    useContext(VoicemailsContext);

  const refreshVoicemailsOnFocus = useCallback(() => {
    refreshVoicemails();
  }, [refreshVoicemails]);

  return (
    <View style={[styles.container, style]}>
      <FlatList
        data={voicemails}
        refreshing={loading}
        onRefresh={refreshVoicemails}
        renderItem={renderVoicemailListItem(onVoicemailPress)}
        showsVerticalScrollIndicator={false}
        keyExtractor={(item) => `voicemail-list-item-${item.id}`}
        onEndReached={nextPage}
        ListEmptyComponent={NoVoicemailsComponent}
      />
    </View>
  );
};

const renderVoicemailListItem = (onPress) => (props) => {
  return <VoicemailListItem {...props} onPress={onPress} />;
};
const VoicemailListItem = ({ item, onPress }) => {
  const onVoicemailPress = () => {
    Engage.markVoicemailAsRead(item.id).then(() => {});
    onPress(item);
  };

  return (
    <TouchableWithoutFeedback onPress={onVoicemailPress}>
      <View style={[styles.voicemail_list__item]}>
        <Row style={{ height: "100%" }}>
          <Col leftCenter pr={8}>
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              style={[styles.voicemail_list__item_name]}
            >
              {item.participant.name}
            </Text>
            <Text
              numberOfLines={1}
              style={[styles.voicemails_list__item_subtext]}
            >
              {dayjs(item.created_at).format("h:mm A - ddd, MMM Do")}
            </Text>
          </Col>

          <Col>
            <Row style={{ height: "100%" }}>
              <Col leftCenter minWidth={100}>
                <Text
                  numberOfLines={1}
                  style={[styles.voicemail_list__item_name]}
                >
                  {item.author?.name}
                </Text>
              </Col>

              <Col rightCenter maxWidth={100}>
                {/* <Text numberOfLines={1}>{getSmartTimestamp(item.createdAt)}</Text> */}
              </Col>

              <Col rightCenter maxWidth={50}>
                <IconButton
                  height={30}
                  width={30}
                  iconName="info"
                  iconColor={item.url ? palette.primary : palette.light_grey}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </View>
    </TouchableWithoutFeedback>
  );
};

const NoVoicemailsComponent = () => {
  return (
    <View style={[styles.no_conversations_component]}>
      <Heading center size={4} color={palette.grey}>
        No voicemails
      </Heading>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  no_conversations_component: {
    textAlign: "center",
    justifyContent: "center",
    paddingTop: 64,
  },
  voicemail_list__item: {
    height: 65,
    paddingHorizontal: 16,
    paddingRight: 8,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: palette.light_grey,
  },
  voicemail_list__item_name: {
    fontWeight: "600",
    fontSize: 16,
  },
  voicemails_list__item_subtext: {
    fontSize: 14,
    color: palette.grey,
  },
  voicemail_list__item_duration: {
    fontSize: 12,
  },
  voicemail_list__item_missed: {
    color: palette.danger,
  },
});

export default VoicemailList;
